import * as React from "react";
import FixedCommentsTable from "./List/FixedCommentsTable";
import { MenuItems } from "./List/MenuItems";
import { ODataParams, Query, Order } from "../../Components/Query";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";

interface FixedCommentsScreenProps {

}

const FixedCommentsScreen = ({ }: FixedCommentsScreenProps): JSX.Element => {
    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();

    const handleRefresh = async (params: ODataParams) => {

        let filter = params.filter ? `(${params.filter}) and ` : '';
        filter += `studySet/studyid eq ${study.id}`;

        return await client.client.getFixedCommentSets(undefined, filter, params.orderby, "studySet,defaultComment,comments", params.top, params.skip, undefined, true);
    }

    const initialOrdering = (): Order[] => {
        return [
            {
                field: "studySet/commentSetType",
                condition: "asc"
            },
            {
                field: "studySet/sessionType",
                condition: "asc"
            },
            {
                field: "entityType",
                condition: "asc"
            }
        ]
    }

    return (<div className="wrapper wrapper-content">
        <div className="row">
            <div className="col-md-12">
                <div className="ibox">
                    <div className="ibox-title">
                        <h2 className="text-primary">Fixed Comments Management</h2>
                        <MenuItems />
                    </div>
                    <div className="ibox-content">
                        <div id="fixedCommentsList">
                            <Query onRefresh={handleRefresh} initialOrdering={initialOrdering()}>
                                <FixedCommentsTable />
                            </Query>
                        </div> 
                    </div>
                    <div className="ibox-footer">
                        <MenuItems />
                    </div>
                </div>
            </div>
        </div>
    </div>);
};

export default FixedCommentsScreen;
